import { apiBasic, apiGet } from "./requests";

export const getOrders = (data = null) => {
  let path = "get-orders-delivery-ready";
  return apiBasic(data, path, "get");
};

export const payOrder = (payload) => {
  let path = `pay-order`;
  return apiBasic(payload, path, "post");
};

export const getOrdersDeliveryReady = () => {
  let path = "get-user-delivery-orders";
  return apiGet(path);
};

export const startDeliveryOrder = (data = null) => {
  let path = "start-order-delivery";
  return apiBasic(data, path, "patch");
};

export const finalizeOrderDelivery = (data = null) => {
  let path = "finalize-order-delivery";
  return apiBasic(data, path, "patch");
};

export const reportDeliveryError = (data = null) => {
  let path = "report-delivery-error";
  return apiBasic(data, path, "post");
};

export const getPaymentMethods = () => {
  let path = "payment-methods";
  return apiGet(path);
};

export const getOrderDetails = (orderId) => apiGet(`order-detailed/${encodeURIComponent(orderId)}`);
